<template>
    <div>
        <breadcrumb
            class="mt-4"
            :links="[
                { msg: 'cart.cart' },
                { msg: 'order.confirm' },
                { msg: 'order.payment' }
            ]"
        />
        <div class="flex flex-col items-center">
            <div class="text-red text-3xl font-black flex items-center">
                <div class="icon w-12 h-12 mr-2">
                    <warning />
                </div>
                {{ $t('order.payment.fail') }}
            </div>
            <p class="mt-4">{{ $t('order.payment.fail.and.retry') }}</p>
            <router-link
                tag="button"
                to="/confirm"
                class="btn bg-primary px-10 mt-4 font-black"
            >
                {{ $t('order.payment.retry') }}
            </router-link>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/breadcrumb.vue';
import warning from '@/assets/svg/warning.svg';
export default {
    components: { warning, breadcrumb }
};
</script>
